import React, { useRef } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Editing,
  Toolbar,
  Item,
  DataGridRef,
  Button as GridButton
} from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import './orders.scss';
import { ordersDataSource } from '../../datasources/ordersDataSource';
import { useParams } from 'react-router-dom';
import { dataGridErrorHandling } from '../../utils/errorHandling';
import { GetOrdiniFilter } from "../../data/models/GetOrdiniFilter";
import PopupOrder, { OrdinePopupHandle } from '../../components/popupOrder/popupOrder';
import PopupOrderReport, { OrderReportPopupHandle } from '../../components/popupOrderReport/popupOrderReport';
import { OrdiniApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { showError } from '../../utils/errorHandling';
import { useTranslation } from 'react-i18next';

export default function Orders() {
  const ordineReportRef = useRef<OrderReportPopupHandle>(null);
  const ordineRef = useRef<OrdinePopupHandle>(null);
  const gridRef = useRef<DataGridRef>(null);
  const params = useParams<Props>();
  const { t } = useTranslation();

  type Props = {
    tipo: string
  }

  let myfilterOrdini = null;
  let myreadonly = false, isBozza = false, isChiuso = false;

  switch (String(params.tipo)) {
    case "bozze":
      myfilterOrdini = GetOrdiniFilter.Temporaneo;
      myreadonly = false;
      isBozza = true;
      isChiuso = false;
      break;
    case "chiusi":
      myfilterOrdini = GetOrdiniFilter.Provvisorio;
      myreadonly = true;
      isBozza = false;
      isChiuso = true;
      break;
    case "storico":
      myfilterOrdini = GetOrdiniFilter.ConfermaOrdine;
      myreadonly = true;
      isBozza = false;
      isChiuso = false;
      break;
    default:
      myfilterOrdini = GetOrdiniFilter.Tutti
      break;

  }

  function HasAttachment(e: any) {
    return e.row.data.idOrdine && e.row.data.idOrdine !== 0;
  }

  function ShowAttachment(e: any) {
    ordineReportRef.current?.show(e.row.data.idOrdine);
  }

  function ConfirmOrder(e: any) {
    const api = new OrdiniApi(apiConfiguration);

    api.closeOrdine({
      idOrdine: e.row.data.idOrdine
    })
      .catch(showError)
      .then(function () {
        gridRef.current?.instance().refresh();
      })
  }

  function ReopenOrder(e: any) {
    const api = new OrdiniApi(apiConfiguration);

    api.openOrdine({
      idOrdine: e.row.data.idOrdine
    })
      .catch(showError)
      .then(function () {
        gridRef.current?.instance().refresh();
      })
  }

  function new_click(e: any) {
    ordineRef.current?.new();
  }

  function edit_click(e: any) {
    ordineRef.current?.edit(e.row.data.idOrdine, e.row.data.idCliente);
  }

  function refreshGrid() {
    // console.log('refresh testata')
    gridRef.current?.instance().refresh();
  }

  return (
    <React.Fragment>
      <h2 className={'content-block'}>{t(params.tipo || '')}</h2>
      <DataGrid
        ref={gridRef}
        key="idOrdine"
        className={'dx-card wide-card'}
        dataSource={ordersDataSource(myfilterOrdini)}
        showBorders={false}
        focusedRowEnabled={true}
        errorRowEnabled={false}
        defaultFocusedRowIndex={0}
        defaultSelectionFilter=""
        columnAutoWidth={true}
        columnHidingEnabled={true}
        onDataErrorOccurred={dataGridErrorHandling}
        onRowUpdating={function (e) {
          e.newData = Object.assign({}, e.oldData, e.newData);
        }}
      >
        <Editing allowUpdating={true} allowAdding={true} allowDeleting={true}>
        </Editing>
        <Paging defaultPageSize={10} />
        <Pager showPageSizeSelector={true} showInfo={true} />
        <FilterRow visible={true} />

        <Column type="buttons" alignment='left'>
          <GridButton name="edit" onClick={edit_click} hint={t ('dettaglio')}/>
          <GridButton name="delete" visible={isBozza} hint={t ('elimina')}/>
          <GridButton hint={t ('confermaordine')} icon="taskcomplete" visible={isBozza} onClick={ConfirmOrder} />
          <GridButton hint={t ('riapreOrdine')} icon="undo" visible={isChiuso} disabled={e=> e.row.data.documentoEvaso } onClick={ReopenOrder} />
          <GridButton hint={t ('visualizzaDoc')} icon="doc" visible={HasAttachment} onClick={ShowAttachment} />
        </Column>

        <Column dataField={'idOrdine'} width={90} hidingPriority={1} allowEditing={false} visible={false} />
        <Column dataField={'numero'} caption={t ('numero')} hidingPriority={6} />
        <Column dataField={'data'} caption={t ('data')} dataType='date' format="shortDate" hidingPriority={6} />
        <Column dataField={'dataConsegna'} caption={t ('dataConsegna')} dataType='date'hidingPriority={5} />
        <Column dataField={'ragioneSociale'} caption={t ('cliente')} hidingPriority={5} />
        <Column dataField={'nomeDeposito'} caption={t ('deposito')} hidingPriority={4} />
        <Column dataField={'note'} caption={t ('note')} hidingPriority={3} />
        <Column dataField={'totaleDocumento'} caption={t ('totaleDocumento')} hidingPriority={2} />
        <Column dataField={'isSigned'} caption={t ('firmato')} hidingPriority={1} />
        <Column dataField={'documentoEvaso'} caption={t ('evaso')} hidingPriority={1} />

        <Toolbar>
          <Item location="after">
            <Button
              icon='refresh'
              onClick={refreshGrid}
            />
            <Button
              icon='add'
              onClick={new_click}
              disabled={myreadonly}
            />
          </Item>
        </Toolbar>
      </DataGrid>

      <PopupOrder ref={ordineRef} tipoOrdine={String(params.tipo)} onChange={refreshGrid} readonly={myreadonly}></PopupOrder>
      <PopupOrderReport ref={ordineReportRef} />

    </React.Fragment>
  )
}

